import type {
    GetQuestionnaireItemsResponseBody,
    IGetQuestionnaireItemsQuery,
    IQuestionnaire,
} from '@common/interfaces/api/questionnairesApi';
import { getUrlQueryParameters } from '@frontend/services/api/queryParameterUtils';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/questionnaires';

export async function getQuestionnaire(questionnaireId: string, signal: AbortSignal): Promise<IQuestionnaire> {
    const url = `${baseUrl}/${questionnaireId}`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}

export async function getQuestionnaireItems(
    questionnaireId: string,
    query: IGetQuestionnaireItemsQuery | undefined,
    signal: AbortSignal
): Promise<GetQuestionnaireItemsResponseBody> {
    const url = getUrlQueryParameters<IGetQuestionnaireItemsQuery>(`${baseUrl}/${questionnaireId}/items`, query);
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}
